import styled from 'styled-components';
import ChildCareSvg from '../../assets/amenities/child-care.svg';

const ChildCareIcon = styled(ChildCareSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default ChildCareIcon;
